import * as webLinks from './web';
import { runtime } from '../runtime';
import { openExternal } from './external';
import { callPhone } from './phone';
const native = runtime.isNative() ? import('./native') : null;
export const links = {
    notificationRoute: () => runtime.isNative() ? '/dashboard' : '/profile/notifications',
    openExternal,
    callPhone,
    openContact: webLinks.openContact,
    async openContactFile(vcard, options) {
        if (!runtime.isNative()) throw new Error('Contact file import requires a native app');
        const { openContactFile } = await import('./contactFile');
        return openContactFile(vcard, options);
    },
    startIncomingLinks: () => native ? native.then(module => module.startIncomingLinks()) : Promise.resolve(),
    onIncomingLink(callback, onReady = () => {}) {
        if (!native) { onReady(); return webLinks.onIncomingLink(callback); }
        let cancelled = false, remove;
        native.then(module => { if (!cancelled) { remove = module.onIncomingLink(callback); onReady(); } }).catch(() => { if (!cancelled) onReady(); });
        return () => { cancelled = true; remove?.(); };
    }
};
export default links;
